import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAppointmentMutationVariables = Types.Exact<{
  shopLocationId: Types.Scalars['String']['input'];
  input: Types.CreateAppointmentInput;
}>;


export type CreateAppointmentMutation = { __typename?: 'Mutation', createAppointment: { __typename?: 'Appointment', id: string, expectedDropoffTime: any, estimatedPickupTime?: any | null, notes?: string | null, appointmentType?: Types.AppointmentType | null, status: Types.AppointmentStatus, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, car?: { __typename?: 'Car', createdAt: any, licensePlate?: string | null, vin?: string | null, id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null } | null } };

export type UpdateAppointmentMutationVariables = Types.Exact<{
  input: Types.UpdateAppointmentInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment: { __typename?: 'Appointment', id: string, expectedDropoffTime: any, estimatedPickupTime?: any | null, notes?: string | null, appointmentType?: Types.AppointmentType | null, status: Types.AppointmentStatus, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null } | null, car?: { __typename?: 'Car', id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null } | null } };

export type AppointmentWizardBodyFragment = { __typename?: 'Appointment', id: string, expectedDropoffTime: any, estimatedPickupTime?: any | null, requestedOn?: any | null, requestedFrom?: string | null, notes?: string | null, appointmentType?: Types.AppointmentType | null, status: Types.AppointmentStatus, shopLocation?: { __typename?: 'ShopLocation', id: string, name: string } | null, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, secondaryPhoneNumber?: string | null, companyName?: string | null, createdAt: any } | null, car?: { __typename?: 'Car', createdAt: any, licensePlate?: string | null, vin?: string | null, id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null } | null, job?: { __typename?: 'Job', jobMetadata: { __typename?: 'JobMetadata', id: string, jobNumber: number, mechanicShopStatus?: Types.JobMechanicShopStatus | null } } | null, callReport?: { __typename?: 'CallReport', id: string, createdAt: any, endReason?: string | null, recordingURL?: string | null, summary?: string | null } | null };

export const AppointmentWizardBodyFragmentDoc = gql`
    fragment AppointmentWizardBody on Appointment {
  id
  expectedDropoffTime
  estimatedPickupTime
  requestedOn
  requestedFrom
  notes
  appointmentType
  status
  shopLocation {
    id
    name
  }
  customer {
    id
    firstName
    lastName
    phoneNumber
    email
    secondaryPhoneNumber
    companyName
    createdAt
  }
  car {
    createdAt
    licensePlate
    vin
    id
    make
    model
    year
    colour
  }
  job {
    jobMetadata {
      id
      jobNumber
      mechanicShopStatus
    }
  }
  callReport {
    id
    createdAt
    endReason
    recordingURL
    summary
  }
}
    `;
export const CreateAppointmentDocument = gql`
    mutation CreateAppointment($shopLocationId: String!, $input: CreateAppointmentInput!) {
  createAppointment(shopLocationId: $shopLocationId, input: $input) {
    id
    expectedDropoffTime
    estimatedPickupTime
    notes
    appointmentType
    status
    customer {
      id
      firstName
      lastName
      phoneNumber
      email
    }
    car {
      createdAt
      licensePlate
      vin
      id
      make
      model
      year
      colour
    }
  }
}
    `;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      shopLocationId: // value for 'shopLocationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation UpdateAppointment($input: UpdateAppointmentInput!) {
  updateAppointment(input: $input) {
    id
    expectedDropoffTime
    estimatedPickupTime
    notes
    appointmentType
    status
    customer {
      id
      firstName
      lastName
      phoneNumber
      email
    }
    car {
      id
      make
      model
      year
      colour
    }
  }
}
    `;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;